module.exports = __webpack_public_path__ + "static/rcc-orr-graph-mobile-29968466b59d4caa5b42bf36ceb0123d.png";